import type { ChatDocument, ChatMessageDocument } from '@models/chat';
import RequestMessage from './RequestMessage';
import { getOrderNumFromContent } from './utils';

interface ReturnDeliveredMessageProps {
  message: ChatMessageDocument;
  chat: ChatDocument;
}

export default function ReturnDeliveredMessage({
  message,
  chat,
}: ReturnDeliveredMessageProps) {
  const orderNumFromContent = getOrderNumFromContent(message.content);

  return (
    <RequestMessage
      message={message}
      chat={chat}
      label="Return Delivered"
      reason={null}
      bodyText={message.content}
      orderNumFallback={orderNumFromContent}
    />
  );
}
